export const ADD_CD_TAB_KEYS = {
  TEST: 'test',
  CERTIFICATE: 'certificate',
  OTHER: 'other',
};
